import vsComponent from './vsAlert'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
